<script setup lang="ts">
  import {
    StripeInvoicesService,
    type SuperUserStripeInvoice as StripeInvoice
  } from '@/types/generated'
  import PaginatedTableView, {
    type FetchDataOptions,
    type PaginatedResponse
  } from '@/components/admin/PaginatedTable.vue'
  import { ROUTES } from '@/router/routes'
  import { formatDateTimeGerman } from '../../../lib/util/formatting'
  import Breadcrumbs from '@/components/admin/breadcrumbs/Breadcrumbs.vue'
  import { ArrowDownOnSquareStackIcon } from '@heroicons/vue/24/outline'
  import { TableCell, TableRow } from '@/components/ui/table'
  import UniqueTableDataCell from '@/components/admin/table/UniqueTableDataCell.vue'

  const fetchInvoices = async (
    options?: FetchDataOptions
  ): Promise<PaginatedResponse<StripeInvoice>> => {
    return StripeInvoicesService.stripeInvoicesList({
      limit: options?.limit,
      offset: options?.offset
    }) as unknown as PaginatedResponse<unknown>
  }
</script>
<template>
  <div>
    <div class="space-y-5 p-2 sm:p-5 sm:py-0 md:pt-5">
      <!-- Page Header -->
      <div class="flex items-center justify-between gap-x-5">
        <Breadcrumbs
          :items="[
            { title: 'Dashboard', to: ROUTES.ADMIN.DASHBOARD },
            { title: 'Invoices', to: ROUTES.ADMIN.PAYMENTS.INVOICES_LIST }
          ]"
        />
        <div class="flex items-center justify-end gap-x-2">
          <router-link
            :to="ROUTES.ADMIN.PAYMENTS.INVOICES_EXPORT"
            class="inline-flex items-center gap-x-2 rounded-lg border border-transparent bg-purple-600 px-3 py-2
              text-sm font-semibold text-white hover:bg-purple-700 focus:outline-none focus:ring-2
              focus:ring-blue-500 disabled:pointer-events-none disabled:opacity-50"
          >
            <ArrowDownOnSquareStackIcon class="size-4 flex-shrink-0" />
            Export
          </router-link>
        </div>
      </div>
      <!-- End Page Header -->

      <!-- Users Table Card -->
      <div class="flex flex-col space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div>
          <!-- Tab Content -->
          <div class="">
            <!-- Table Section -->
            <div
              class="[&amp;::-webkit-scrollbar]:h-2 [&amp;::-webkit-scrollbar-thumb]:rounded-full
                [&amp;::-webkit-scrollbar-track]:bg-gray-100 [&amp;::-webkit-scrollbar-thumb]:bg-gray-300
                &amp;::-webkit-scrollbar-track]:bg-neutral-700 &amp;::-webkit-scrollbar-thumb]:bg-neutral-500
                overflow-x-auto"
            >
              <div class="inline-block min-w-full align-middle">
                <!-- Table -->
                <PaginatedTableView :fetchData="fetchInvoices">
                  <template #table-head>
                    <TableCell>UUID</TableCell>
                    <TableCell>Datetime</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell></TableCell>
                  </template>
                  <template #table-row="{ items: invoices }: { items: StripeInvoice[] }">
                    <TableRow
                      v-for="invoice in invoices"
                      :key="invoice.uuid"
                    >
                      <UniqueTableDataCell :truncate="true">
                        {{ invoice.uuid }}
                      </UniqueTableDataCell>
                      <TableCell>
                        {{ invoice.created ? formatDateTimeGerman(invoice.created) : '-' }}
                      </TableCell>
                      <TableCell>
                        {{
                          invoice.amount_due
                            ? (invoice.amount_due / 100).toFixed(2) +
                              ' ' +
                              invoice.currency.toUpperCase()
                            : '-'
                        }}
                      </TableCell>
                      <TableCell>
                        {{ invoice.customer.name }}
                      </TableCell>
                      <!--                      <TableCell>-->
                      <!--                        <router-link-->
                      <!--                          class="inline-flex items-center gap-x-2 rounded-lg border border-transparent text-sm font-semibold-->
                      <!--                            text-blue-600 hover:text-blue-800 disabled:pointer-events-none disabled:opacity-50-->
                      <!--                            dark:text-blue-500 dark:hover:text-blue-400"-->
                      <!--                          :to="ROUTES.ADMIN.VOICE.CALL_DETAIL.replace(':uuid', call.uuid)"-->
                      <!--                          type="button"-->
                      <!--                        >-->
                      <!--                          Details-->
                      <!--                        </router-link>-->
                      <!--                      </TableCell>-->
                    </TableRow>
                  </template>
                </PaginatedTableView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
